import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  FormArray,
  FormGroup,
} from '@angular/forms';

export function uniqueValueValidator(
  fieldName: string,
  errorKey: string = 'duplicated'
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!(control instanceof FormArray)) return null;

    const formArray = control as FormArray;

    // Mapa: valorNormalizado -> lista de índices onde aparece
    const occurrences = new Map<string, number[]>();

    formArray.controls.forEach((fg, index) => {
      const group = fg as FormGroup;
      const raw = group.get(fieldName)?.value;

      // normaliza pro "id" (no seu caso vem como {label,value})
      const id = raw?.value ?? raw ?? null;
      if (!id) return;

      const key = String(id);
      const list = occurrences.get(key) ?? [];
      list.push(index);
      occurrences.set(key, list);
    });

    // 1) Primeiro, remove o erro "duplicate" de todos (sem mexer nos outros erros)
    formArray.controls.forEach((fg) => {
      const c = (fg as FormGroup).get(fieldName);
      if (!c) return;

      const errors = c.errors;
      if (!errors?.[errorKey]) return;

      const { [errorKey]: _, ...rest } = errors;
      const nextErrors = Object.keys(rest).length ? rest : null;

      // evita re-trigger desnecessário
      if (JSON.stringify(c.errors) !== JSON.stringify(nextErrors)) {
        c.setErrors(nextErrors, { emitEvent: false });
      }
    });

    // 2) Agora seta erro SOMENTE no ÚLTIMO índice de cada valor duplicado
    occurrences.forEach((indexes) => {
      if (indexes.length < 2) return;

      const lastIndex = indexes[indexes.length - 1];
      const lastGroup = formArray.at(lastIndex) as FormGroup;
      const lastControl = lastGroup.get(fieldName);

      if (!lastControl) return;

      const current = lastControl.errors ?? {};
      const next = { ...current, [errorKey]: true };

      // se já tem, não seta de novo
      if (!current[errorKey]) {
        lastControl.setErrors(next, { emitEvent: false });
      }
    });

    // Não precisa retornar erro no array (você quer mostrar no campo).
    return null;
  };
}
